<div class="admin-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
      @if (filterGroup.filter_group_key) {
<span> {{ filterGroup.filter_group_key }}</span>
}
    </h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    <!-- Section 1: Filter -->
    @if (!loading) {
<form #saveFilterFrm="ngForm" novalidate>
      <div class="acc-section">
        <div class="acc-heading" (click)="filterSectionOpen = !filterSectionOpen">
          <span>Filter:</span>
          <i class="glyphicon"
             [ngClass]="filterSectionOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right'"></i>
        </div>
        @if (filterSectionOpen) {
<div class="acc-body">
          <div class="btn btn-success btn-sm add-btn" (click)="addFilter()">
            More Filters? Click to Add <i class="fa fa-plus-circle"></i>
          </div>

          @for (f of filtersList; track $index; let i = $index) {
<div class="filter-row">
            <div class="delete-cell">
              <i class="fa fa-minus-circle color-red"
                 ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Row" direction="right"
                 (click)="confirmDeleteFilter(f.filter_key, i)"></i>
            </div>

            <!-- Column 1: Filter Key / Param Name / Label / UI Type -->
            <div class="filter-col">
              @if (f.filter_key) {
<div class="field">
                <label class="control-label">Filter Key</label>
                <p><b>{{ f.filter_key }}</b></p>
              </div>
}
              <div class="field">
                <label class="control-label">Param Name</label>
                <input type="text" class="form-control"
                       [name]="'param_name_' + i"
                       placeholder="Filter Param Name"
                       [(ngModel)]="f.param_name"
                       [class.error-field]="isParamNameMissing(i)" />
                @if (isParamNameMissing(i)) {
<span class="form-error-text">Param Name is required.</span>
}
              </div>
              <div class="field">
                <label class="control-label">Label</label>
                <input type="text" class="form-control"
                       [name]="'label_' + i"
                       placeholder="Filter Label"
                       [(ngModel)]="f.label"
                       [class.error-field]="isLabelMissing(i)" />
                @if (isLabelMissing(i)) {
<span class="form-error-text">Label is required.</span>
}
              </div>
              <div class="field">
                <label class="control-label">UI Type</label>
                <select class="form-control"
                        [name]="'ui_type_' + i"
                        [(ngModel)]="f.ui_type"
                        [class.error-field]="isUITypeMissing(i)">
                  <option [ngValue]="''"></option>
                  @for (s of uiType; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
                </select>
                @if (isUITypeMissing(i)) {
<span class="form-error-text">UI Type is required.</span>
}
              </div>
              @if (f.ui_type === 'Other') {
<div class="field">
                <label class="control-label">UI Type</label>
                <input type="text" class="form-control"
                       [name]="'ui_type_other_' + i"
                       placeholder="Filter UI Type"
                       [(ngModel)]="f.ui_type_other"
                       [class.error-field]="isUITypeOtherMissing(i)" />
                @if (isUITypeOtherMissing(i)) {
<span class="form-error-text">Custom UI Type is required.</span>
}
              </div>
}
            </div>

            <!-- Column 2: Multiple / Data URL / Data Type / Default Value -->
            <div class="filter-col">
              <div class="field">
                <label class="control-label">Multiple</label>
                <select class="form-control"
                        [name]="'multiple_' + i"
                        [(ngModel)]="f.multiple"
                        [class.error-field]="isMultipleMissing(i)">
                  <option [ngValue]="''">-- Select --</option>
                  @for (m of multipleOptions; track $index) {
<option [ngValue]="m.value">{{ m.name }}</option>
}
                </select>
                @if (isMultipleMissing(i)) {
<span class="form-error-text">Multiple is required.</span>
}
              </div>
              @if (f.data_type === 'load') {
<div class="field">
                <label class="control-label">Data URL</label>
                <input type="text" class="form-control"
                       [name]="'data_url_' + i"
                       placeholder="Filter Data Url"
                       [(ngModel)]="f.data_url"
                       [class.error-field]="isDataUrlMissing(i)" />
                @if (isDataUrlMissing(i)) {
<span class="form-error-text">Data URL is required.</span>
}
              </div>
}
              <div class="field">
                <label class="control-label">Data Type</label>
                <select class="form-control"
                        [name]="'data_type_' + i"
                        [(ngModel)]="f.data_type"
                        [class.error-field]="isDataTypeMissing(i)">
                  <option [ngValue]="''">-- Select --</option>
                  @for (d of dataTypeOptions; track $index) {
<option [ngValue]="d.value">{{ d.name }}</option>
}
                </select>
                @if (isDataTypeMissing(i)) {
<span class="form-error-text">Data Type is required.</span>
}
              </div>
              <div class="field">
                <label class="control-label">Default Value</label>
                <input type="text" class="form-control"
                       [name]="'default_value_' + i"
                       placeholder='{"LABEL":"Select Tax Year","VALUE":""}'
                       [(ngModel)]="f.default_value" />
              </div>
            </div>

            <!-- Column 3: Required / Refresh List / Static Value -->
            <div class="filter-col">
              <div class="field">
                <label class="control-label">Required</label>
                <select class="form-control"
                        [name]="'required_' + i"
                        [(ngModel)]="f.required"
                        [class.error-field]="isRequiredMissing(i)">
                  <option [ngValue]="''">-- Select --</option>
                  @for (r of requiredOptions; track $index) {
<option [ngValue]="r.value">{{ r.name }}</option>
}
                </select>
                @if (isRequiredMissing(i)) {
<span class="form-error-text">Required is required.</span>
}
              </div>
              <div class="field">
                <label class="control-label">Refresh List</label>
                <input type="text" class="form-control"
                       [name]="'refresh_list_' + i"
                       placeholder="RefreshList by order example 1,45"
                       [(ngModel)]="f.refresh_list" />
              </div>
              @if (f.data_type === 'static') {
<div class="field">
                <label class="control-label">Static Value</label>
                <textarea class="form-control"
                          [name]="'static_values_' + i"
                          [(ngModel)]="f.static_values"
                          [class.error-field]="isStaticJsonMissing(i)"></textarea>
                @if (isStaticJsonMissing(i)) {
<span class="form-error-text">Valid JSON is required.</span>
}
              </div>
}
            </div>
          </div>
}

          @if (filtersList.length > 0) {
<div class="row-actions">
            <button class="btn btn-warning btn-sm" type="button" (click)="clearFilter()">Clear</button>
            <button class="btn btn-info btn-sm" type="button" (click)="saveFilters()">
              @if (crudLoadingFilter) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
            </button>
          </div>
}
        </div>
}
      </div>
    </form>
}

    <!-- Section 2: Filter Group -->
    @if (!loading) {
<form #filterGroupForm="ngForm" novalidate>
      <div class="acc-section">
        <div class="acc-heading" (click)="filterGroupSectionOpen = !filterGroupSectionOpen">
          <span>Filter Group:</span>
          <i class="glyphicon"
             [ngClass]="filterGroupSectionOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right'"></i>
        </div>
        @if (filterGroupSectionOpen) {
<div class="acc-body">
          <div class="fg-row">
            @if (filterGroup.filter_group_key) {
<div class="field">
              <label class="control-label">Filter Group Key</label>
              <p><b>{{ filterGroup.filter_group_key }}</b></p>
            </div>
}
            <div class="field">
              <label class="control-label">Filter Group Name</label>
              <input type="text" class="form-control" name="group_name"
                     placeholder="Filter Group Name"
                     [(ngModel)]="filterGroup.filter_group_name"
                     [class.error-field]="isGroupNameMissing()" />
              @if (isGroupNameMissing()) {
<span class="form-error-text">Filter Group Name is required.</span>
}
            </div>
            <div class="field">
              <label class="control-label">Filter Group Type</label>
              <input type="text" class="form-control" name="filter_group_type"
                     placeholder="Filter Group Type"
                     [(ngModel)]="filterGroup.filter_group_type"
                     [class.error-field]="isGroupTypeMissing()" />
              @if (isGroupTypeMissing()) {
<span class="form-error-text">Filter Group Type is required.</span>
}
            </div>
            <div class="field">
              <label class="control-label">Filter Group Desc</label>
              <input type="text" class="form-control" name="filter_group_desc"
                     placeholder="Filter Group Descritption"
                     [(ngModel)]="filterGroup.filter_group_desc" />
            </div>
          </div>
        </div>
}
      </div>

      <!-- Section 3: Filter Map -->
      <div class="acc-section">
        <div class="acc-heading" (click)="filterMapSectionOpen = !filterMapSectionOpen">
          <span>Filter Map:</span>
          <i class="glyphicon"
             [ngClass]="filterMapSectionOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right'"></i>
        </div>
        @if (filterMapSectionOpen) {
<div class="acc-body">
          <div class="btn btn-success btn-sm add-btn" (click)="addFilterMap()">
            More Filters Map? Click to Add <i class="fa fa-plus-circle"></i>
          </div>

          @for (fm of filterMapList; track $index; let i = $index) {
<div class="filter-map-row">
            <div class="delete-cell">
              <i class="fa fa-minus-circle color-red"
                 ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Row" direction="right"
                 (click)="confirmDeleteFilterMap(fm.filter_map_key, i)"></i>
            </div>
            @if (fm.filter_map_key) {
<div class="field key-field">
              <label class="control-label">Filter Map Key</label>
              <p><b>{{ fm.filter_map_key }}</b></p>
            </div>
}
            <div class="field">
              <label class="control-label">Filter Key</label>
              <select class="form-control"
                      [name]="'filter_map_filter_key_' + i"
                      [(ngModel)]="fm.filter_key"
                      [class.error-field]="isMapFilterKeyMissing(i)">
                <option [ngValue]="''">-- Select --</option>
                @for (s of allFiltersForMap; track $index) {
<option [ngValue]="s.filter_key">
                  {{ s.filter_key }} - {{ s.label }}
                </option>
}
              </select>
              @if (isMapFilterKeyMissing(i)) {
<span class="form-error-text">Filter Key is required.</span>
}
            </div>
            <div class="field">
              <label class="control-label">Filter Priority</label>
              <input type="text" class="form-control"
                     [name]="'filter_priority_' + i"
                     placeholder="Filter Priority"
                     [(ngModel)]="fm.filter_priority"
                     [class.error-field]="isMapPriorityMissing(i)" />
              @if (isMapPriorityMissing(i)) {
<span class="form-error-text">Filter Priority is required.</span>
}
            </div>
          </div>
}
        </div>
}
      </div>
    </form>
}
  </div>

  <!-- Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="saveFilterGroup()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>

<!-- Confirm delete modal -->
@if (showConfirmDelete) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmDeleteConfig"
    [visible]="false"
    (confirmed)="onConfirmDeleteYes()"
    (cancelled)="onConfirmDeleteNo()"
    (closed)="onConfirmDeleteNo()">
  </gtw-confirmation-modal>
</div>
}
